import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AppBridgeProvider, useAppBridge } from './contexts/AppBridgeContext';
import Home from './pages/Home';

// Main App Content
const AppContent: React.FC = () => {
  const { isLoading, error } = useAppBridge();

  // 如果正在加载,显示加载状态
  if (isLoading) {
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}>
        加载中...
      </div>
    );
  }

  // 如果有错误,显示错误页面
  if (error) {
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 16
      }}>
        <div style={{ color: '#ff4d4f', fontSize: 18 }}>出错了</div>
        <div>{error}</div>
      </div>
    );
  }

  // 显示应用首页
  return <Home />;
};

// Main App
const App: React.FC = () => {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
      <AppBridgeProvider>
        <AppContent />
      </AppBridgeProvider>
    </ConfigProvider>
  );
};

export default App;
